import DOMPurify from 'isomorphic-dompurify';
import * as cdLogger from 'services/cdLogger';
import { isString } from 'lodash-es';
import { tryTestRegex } from 'utilities/global';
import { REGEXES } from 'consts';

const sanitizer = DOMPurify(window);

export const sanitizeInput = input => {
  if (!isString(input)) return '';

  const javascriptExpressionRegex = new RegExp(REGEXES.JAVASCRIPT_INLINE_EXPRESSION, 'i');
  const isIncludesJavascriptExpression = tryTestRegex(javascriptExpressionRegex, input);
  if (isIncludesJavascriptExpression) {
    cdLogger.verbose(`input includes javascript expression, input = ${input}`);
    return '';
  }

  const sanitizedInput = sanitizer.sanitize(input);
  if (sanitizedInput !== input) {
    cdLogger.verbose(
      `sanitized input is different than the original one, input = ${input} | sanitizedInput = ${sanitizedInput}`
    );
  }
  return sanitizedInput || '';
};
